import { Image } from '@unpic/react';

export type StaticImageProps = {
  alt: string;
  src: string;
} & Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'height' | 'width'>;

export function StaticImage({ src, alt, ...props }: StaticImageProps): React.ReactElement {
  return <Image layout="fullWidth" src={src} alt={alt} {...props} />;
}
